// this module contains functions for init and accessing translations
// the translations are gathered using scraping fo-site listing page HTML from <script id="app.locale" type="application/json-ld">
// TODO: there are no all translations in JSON-LD and some labels are hardcoded in code
//  These labels are marked with 'Add to translations'. Add these labels to JSON-LD if necessary in future
//  or wait as soon as new translation system is implemented in UBO (Universal Back Office)
import * as log from 'loglevel';

const template = require('lodash.template');

let translations = {};

const Locale = {
  initTranslations: (newTranslations) => {
    translations = newTranslations;
  },

  /**
   * Get localised string
   * @param {string} key
   * @returns {string}
   */
  getString(key) {
    if (typeof translations[key] === 'undefined') {
      log.warn(`No translations defined for key ${key}.`);
    }

    return (typeof translations[key] !== 'undefined')
      ? translations[key]
      : key;
  },

  /**
   * Get localised formatted string
   * @param {string} key
   * @param {object} values
   * @returns {string}
   */
  getFormattedString(key, values) {
    if (typeof translations[key] === 'undefined') {
      console.warn(`No translations defined for key ${key}.`);

      return key;
    }

    // parameteres are in {} in the template
    const compile = template(translations[key], { interpolate: /{([\s\S]+?)}/g });

    let compileResult = null;
    try {
      compileResult = compile(values);
    } catch (e) {
      log.error(`Error during compiling formatted translation: ${key}`);
      log.error(e.message);
    }

    if (compileResult) {
      // OK
      return compile(values);
    }

    // compiling failed so message is returned
    return key;
  }
};

export default Locale;
